import { wccModules } from 'enums/wccModules';
import { inject, injectable } from 'inversify';
import { Observable, PureComputed } from 'knockout';
import { IWCCStorageManager } from 'managers/iStorage';
import TopicPeopleTagsManager from 'managers/tags/topicPeople';
import { withEffect } from 'mixins/withEffect';
import { EffectsContainer } from 'mixins/withEffects';
import { DataFormat } from 'select2';
import ThreadEditorPickerVM, { ThreadEditorPickerVMConfig } from './picker';
import ThreadEditorVM from './thread';
import './visibilityTagsPicker.html';
import './visibilityTagsPicker.scss';

components.preload('wcc-select-2');

export interface ThreadEditorVisibilityTagsPickerVMConfig {
    editor: ThreadEditorVM
}

@injectable()
export default class ThreadEditorVisibilityTagsPickerVM {
    pickerConfig: ThreadEditorPickerVMConfig
    picker: Observable<ThreadEditorPickerVM | undefined> = ko.observable()

    isVisible: PureComputed<boolean>

    constructor(
        @inject(wccModules.componentConfig) { editor }: ThreadEditorVisibilityTagsPickerVMConfig,
        @inject(wccModules.componentInfo) info: ko.components.ComponentInfo,
        @inject(wccModules.storage) storage: IWCCStorageManager,
        @inject(wccModules.effects) effects: EffectsContainer
    ) {
        const tagsManager = storage.get(TopicPeopleTagsManager, [editor.topicId]);
        const isLoadingTags = tagsManager.pluck('loading', true);
        const tags = tagsManager.pluck('tags', []);

        this.pickerConfig = {
            data: tags.map(t => (<DataFormat>{ id: t.contentTagId() ?? '', text: t.tagValue() })),

            isLoading: isLoadingTags,
            isMultiple: true
        }

        this.isVisible = ko.pureComputed(() => editor.threadVisibility() === enums.ThreadVisibility.Tags.value);

        effects.register(isReady => {
            if (!isReady) {
                editor.threadVisibilityTagIDs([]);
            } else {
                return withEffect(picker => {
                    if (picker != undefined) {
                        return [
                            withEffect(editorTagsIDs => {
                                if (!system.isTheSameList(editorTagsIDs, picker.selection()))
                                    picker.selection(_.clone(editorTagsIDs));
                            }, [editor.threadVisibilityTagIDs]),

                            withEffect(selectedTagsIDs => {
                                if (!system.isTheSameList(selectedTagsIDs, editor.threadVisibilityTagIDs()))
                                    editor.threadVisibilityTagIDs(_.clone(selectedTagsIDs));
                            }, [picker.selection]),
                        ]
                    }
                }, [this.picker]);
            }
        }, [this.isVisible]);

        ko.applyBindingsToNode(info.element, {
            'visible': this.isVisible,

            'css': {
                'thread-editor-visibility-tags-picker': true
            }
        }, this);
    }
}